import http from '../../../Utils/http';
import responseMessageHandler from '../../../Utils/ResponseMessageHandler';

const getDisplayCampaignCount = {
  name: 'getDisplayCampaignCount',
  state: {
    loading: false,
    error: '',
    campaignsCount: 0,
    displaysCount: 0,
  },
  reducers: {
    getRequested(state) {
      return {
        ...state,
        loading: true,
        error: '',
        campaignsCount: 0,
        displaysCount: 0,
      };
    },

    getReceived(state, payload) {
      return {
        ...state,
        loading: false,
        error: '',
        campaignsCount: payload.campaignsCount,
        displaysCount: payload.displaysCount,
      };
    },

    getRequestFailed(state, payload) {
      return {
        ...state,
        loading: false,
        error: payload,
      };
    },
  },
  effects: (dispatch) => ({
    async getCount() {
      try {
        const userInfo = JSON.parse(localStorage.getItem('userInfo'));
        const orgId = userInfo?.org_id;
        const url = `savvy/organization/campaign-display-count/${orgId}`;
        this.getRequested();
        const response = await http.get(url);
        if (response && response?.data) {
          this.getReceived({
            campaignsCount: response.data.data.campaignsCount,
            displaysCount: response.data.data.displaysCount,
          });
        }
      } catch (err) {
        this.getRequestFailed(err.message);
        dispatch({
          type: 'helper/show',
          payload: {
            type: 'error',
            message: responseMessageHandler.show(err.message),
            show: true,
          },
        });
      }
    },
  }),
};

export default getDisplayCampaignCount;

